import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'

export default function ProjectDetailModal({ open, setOpen, projectDetail }) {

    const cancelButtonRef = useRef(null)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl">
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div>

                                        <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">

                                            <div className="sm:col-span-3">
                                                <div className="min-w-0 flex-auto">
                                                    <p className="text-sm font-semibold leading-6 text-gray-900">Project Name</p>
                                                    <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.ProjectName || "NA"}</p>
                                                </div>
                                            </div>

                                            <div className="sm:col-span-full">
                                                <p className="text-sm font-semibold leading-6 text-gray-900">Project Description</p>
                                                <p className="mt-1  text-sm leading-5 text-gray-500">{projectDetail.ProjectDescription || "NA"}</p>
                                            </div>
                                            <div className="sm:col-span-full">

                                                <p className="text-sm font-semibold leading-6 text-gray-900">Concept</p>
                                                <p className="mt-1 text-sm leading-5 text-gray-500">{projectDetail.Concept || "NA"}</p>
                                            </div>

                                            <div className="sm:col-span-full">
                                                <div className="min-w-0 flex-auto">
                                                    <p className="text-sm font-semibold leading-6 text-gray-900">Innovation</p>
                                                    <p className="mt-1 text-sm leading-5 text-gray-500">{projectDetail.Innovation || "NA"}</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-12">
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Area</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Area || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Year</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Years || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Country</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail?.Country?.countryName || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Typology Category</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.TypologyCategory || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Typology SubCategory</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.TypologySubCategory || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Phase</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Phase || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Style</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Style || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Materials</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Materials || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Color</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Colors || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Rendering</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Rendering || "NA"}</p>
                                                    </div>
                                                </div>
                                                <div className="sm:col-span-3">
                                                    <div className="min-w-0 flex-auto">
                                                        <p className="text-sm font-semibold leading-6 text-gray-900">Modeling</p>
                                                        <p className="mt-1 truncate text-sm leading-5 text-gray-500">{projectDetail.Modeling || "NA"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-5'>
                                            <div className="grid grid-cols-1 gap-10 mt-5 sm:grid-cols-2 lg:grid-cols-8">
                                                {projectDetail.ImageUrls.map((img) => (
                                                    <img
                                                        src={img}
                                                        alt="Project"
                                                        className="w-full  shadow-md object-cover cursor-pointer"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root >
    )
}
